import styles from './ListEmptyState.module.css'

export function ListEmptyState({children}: React.PropsWithChildren) {
  return (
    <div className={styles.emptyStateContainer}>
      <strong>{children}</strong>
    </div>
  )
}

try{ ListEmptyState.displayName ||= 'ListEmptyState' } catch {}